import type { GridColumnHeaderParams } from '@mui/x-data-grid-pro';
import { QuestionMark } from '@tempo-io/sui-icons';
import type { ComponentType } from 'react';
import { HeaderWithIconFormatter } from '@/features/items/components/data-table/formatters';

export const renderColumnHeader =
  (Icon?: ComponentType<{ className?: string }>) => (params: GridColumnHeaderParams) => {
    const IconComponent = Icon ?? QuestionMark;
    return (
      <HeaderWithIconFormatter
        icon={<IconComponent className="mr-2" />}
        text={params.colDef.headerName ?? ''}
      />
    );
  };
